<template>
<CRow>
    <CCol col="12" sm="8" class="mx-auto">
        <CCard>
            <CCardBody>
                <SimpleForm :store="store" :submit="submit" ref="simpleForm" />
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { SimpleForm } from './partials'
import { CategoryParent } from '@/constants'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Edit',

    components: {
        SimpleForm,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.categories()
        })
    },

    data() {
        return {
            id: this.$route.params.id,
        }
    },

    computed: {
        ...mapGetters('store', [
            'storeById'
        ]),
        store() {
            return this.storeById(this.id)
        },
    },

    methods: {
        ...mapActions({
            edit: 'store/edit',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            fetchCategories: 'category/fetch',
        }),
        categories() {
            if (!this.$policy('store').edit) {
                return
            }

            this.fetchCategories({
                no_paginate: true,
                parent: {
                    slug: CategoryParent.STORE_PARENT
                }
            })
        },
        submit() {
            const simpleForm = this.$refs.simpleForm
            this.setShowLoading()
            this.resetMsg()

            this.edit(this.store).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.updateStore'),
                    type: 'success'
                })
            }).catch(result => {
                if(result.data) {
                    simpleForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
    }
}
</script>